module.exports = __webpack_public_path__ + "static/blog-10-d879918e63f884ce6523f2b1ab009b97.png";